import { render, staticRenderFns } from "./banner3.vue?vue&type=template&id=3feace39&scoped=true&"
import script from "./banner3.vue?vue&type=script&lang=js&"
export * from "./banner3.vue?vue&type=script&lang=js&"
import style0 from "./banner3.vue?vue&type=style&index=0&id=3feace39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feace39",
  null
  
)

export default component.exports